<div class="recipient-dropdown">
  <div class="recipient-search__label">Select recipients</div>
  <div class="recipient-search">
    <img src="../../../assets/search.svg" alt="Search" />
    <input
      type="text"
      placeholder="Search"
      [(ngModel)]="searchQuery"
      (focus)="handleSearchFocus()"
      (blur)="handleSearchBlur()"
    />
  </div>

  <div
    class="recipient-list"
    *ngIf="isSearchFocused || searchQuery.trim().length > 0"
  >
    <button
      type="button"
      class="recipient-item"
      *ngFor="let user of filteredUsers"
      (mousedown)="$event.preventDefault()"
      (click)="toggleUser(user)"
    >
      <span>{{ user?.name }}</span>
      <img
        *ngIf="isSelected(user)"
        src="../../../assets/check.svg"
        alt="selected"
      />
    </button>
    <div class="recipient-empty" *ngIf="filteredUsers.length === 0">
      No results
    </div>
  </div>

  <div class="recipient-selected">
    <div class="recipient-selected__title">
      Selected({{ selectedUsers.length }})
    </div>
    <div class="recipient-selected__list">
      <span class="recipient-selected__pill" *ngFor="let user of selectedUsers">
        {{ user?.name }}
        <button
          type="button"
          class="recipient-selected__remove"
          (click)="removeUser(user)"
          aria-label="Remove"
        >
          ×
        </button>
      </span>
    </div>
  </div>
</div>
